var map = {
	"./dark/bassclef.png": 709,
	"./dark/flat.png": 710,
	"./dark/natural.png": 711,
	"./dark/none.png": 712,
	"./dark/note1.png": 713,
	"./dark/note16.png": 714,
	"./dark/note2.png": 715,
	"./dark/note32.png": 716,
	"./dark/note4.png": 717,
	"./dark/note8.png": 718,
	"./dark/pianoroll.png": 719,
	"./dark/rest1.png": 720,
	"./dark/rest16.png": 721,
	"./dark/rest2.png": 722,
	"./dark/rest4.png": 723,
	"./dark/rest8.png": 724,
	"./dark/score.png": 725,
	"./dark/sharp.png": 726,
	"./dark/trebleclef.png": 727,
	"./light/bassclef.png": 728,
	"./light/flat.png": 729,
	"./light/natural.png": 730,
	"./light/none.png": 731,
	"./light/note1.png": 732,
	"./light/note16.png": 733,
	"./light/note2.png": 734,
	"./light/note32.png": 735,
	"./light/note4.png": 736,
	"./light/note8.png": 737,
	"./light/pianoroll.png": 738,
	"./light/rest1.png": 739,
	"./light/rest16.png": 740,
	"./light/rest2.png": 741,
	"./light/rest4.png": 742,
	"./light/rest8.png": 743,
	"./light/score.png": 744,
	"./light/sharp.png": 745,
	"./light/trebleclef.png": 746
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 708;